import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import api from '../../api'
import { env } from '../../config/env'
import { ProjectContext } from '../../contexts'
import { GlobalData as GlobalDataItem, GlobalDataSummary } from '../../types'
import { DataTable, Heading } from '../../ui'
import CodeExample from '../../ui/CodeExample'
import Modal from '../../ui/Modal'
import './GlobalData.css'

export default function GlobalData() {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)
    const [globals, setGlobals] = useState<GlobalDataSummary[]>()
    const [viewing, setViewing] = useState<GlobalDataItem>()

    useEffect(() => {
        api.globals.all(project.id)
            .then(setGlobals)
            .catch(() => setGlobals([]))
    }, [project.id])

    const handleSelect = async ({ key }: GlobalDataSummary) => {
        setViewing(await api.globals.get(project.id, key))
    }

    return (
        <>
            <Heading title={t('global_data')} size="h3">
                {t('global_data_description')}
            </Heading>
            <DataTable
                items={globals}
                isLoading={!globals}
                itemKey={({ item }) => item.key}
                columns={[
                    { key: 'key', title: t('key') },
                    { key: 'updated_at', title: t('updated_at') },
                ]}
                emptyMessage={
                    <>
                        {t('global_data_empty')}{' '}
                        <a href={`${env.api.baseURL}/v1/openapi.json`} target="_blank" rel="noreferrer">{t('global_data_api_docs')}</a>
                    </>
                }
                onSelectRow={handleSelect}
            />
            <Modal
                open={!!viewing}
                onClose={() => setViewing(undefined)}
                title={viewing?.key}
                size="large"
            >
                {viewing && (
                    <div className="global-data-value">
                        <CodeExample code={JSON.stringify(viewing.data, null, 4)} />
                    </div>
                )}
            </Modal>
        </>
    )
}
